import {format, parse} from '@legacy/js/date/date-fns.js';
import ApplicationMemberFile from './ApplicationMemberFile';
import ParameterValue from './ParameterValue';

export default class ApplicationMember {

    static fromData(data) {
        if (!data) {
            return;
        }

        let applicationMember = new ApplicationMember();
        applicationMember.id = data.id;

        applicationMember.isPayer = data.isPayer;
        applicationMember.copyAddressOfPayer = data.copyAddressOfPayer;
        applicationMember.isMember = data.isMember ?? false;

        // Stammdaten
        applicationMember.title = ParameterValue.fromData(data.title);
        applicationMember.firstname = data.firstname;
        applicationMember.lastname = data.lastname;
        applicationMember.birthdate = data.birthdate;
        applicationMember.gender = data.gender;

        // Kontaktdaten
        applicationMember.company = data.company;
        applicationMember.street = data.street;
        applicationMember.coAddress = data.coAddress;
        applicationMember.zip = data.zip;
        applicationMember.city = data.city;
        applicationMember.countryCode = data.countryCode ?? 'DE';
        applicationMember.email = data.email;
        applicationMember.phone = data.phone;
        applicationMember.phoneBusiness = data.phoneBusiness;
        applicationMember.mobile = data.mobile;
        applicationMember.mobileBusiness = data.mobileBusiness;

        // Vertragsdaten
        applicationMember.contractStart = data.contractStart;
        applicationMember.departments = data.departments;
        applicationMember.passiveContractState = data.passiveContractState ?? false;

        // Zahlungsdaten
        applicationMember.invoicePayment = data.invoicePayment ?? false;
        applicationMember.sepaPayment = data.sepaPayment ?? false;
        applicationMember.paymentInterval = data.paymentInterval;
        applicationMember.accountHolder = data.accountHolder;
        applicationMember.iban = data.iban;
        applicationMember.bic = data.bic;
        applicationMember.acceptSepa = data.acceptSepa ?? false;

        // Weitere Informationen
        applicationMember.emergencyContact = data.emergencyContact;
        applicationMember.additionalInformation = data.additionalInformation;
        applicationMember.familyMembers = data.familyMembers;
        applicationMember.acceptDataProtection = data.acceptDataProtection ?? false;
        applicationMember.acceptStatute = data.acceptStatute ?? false;
        applicationMember.acceptContributionRegulations = data.acceptContributionRegulations ?? false;
        applicationMember.member = data.member;
        applicationMember.hasFilesUploadedByMember = data.hasFilesUploadedByMember;
        applicationMember.files = data.files.data.map(file => ApplicationMemberFile.fromData(file));
        applicationMember.filterFlags = data.filterFlags;
        applicationMember.classifications = data.classifications;

        applicationMember.open = false;

        return applicationMember;
    }

    duplicate() {
        let applicationMember = new ApplicationMember();
        applicationMember.id = this.id;

        applicationMember.isPayer = this.isPayer;
        applicationMember.copyAddressOfPayer = this.copyAddressOfPayer;
        applicationMember.isMember = this.isMember ?? false;

        // Stammdaten
        applicationMember.title = this.title;
        applicationMember.firstname = this.firstname;
        applicationMember.lastname = this.lastname;
        applicationMember.birthdate = this.birthdate;
        applicationMember.gender = this.gender;

        // Kontaktdaten
        applicationMember.company = this.company;
        applicationMember.street = this.street;
        applicationMember.coAddress = this.coAddress;
        applicationMember.zip = this.zip;
        applicationMember.city = this.city;
        applicationMember.countryCode = this.countryCode;
        applicationMember.email = this.email;
        applicationMember.phone = this.phone;
        applicationMember.phoneBusiness = this.phoneBusiness;
        applicationMember.mobile = this.mobile;
        applicationMember.mobileBusiness = this.mobileBusiness;

        // Vertragsdaten
        applicationMember.contractStart = this.contractStart;
        applicationMember.departments = this.departments;
        applicationMember.teams = this.teams;
        applicationMember.passiveContractState = this.passiveContractState;

        // Zahlungsdaten
        applicationMember.invoicePayment = this.invoicePayment;
        applicationMember.sepaPayment = this.sepaPayment;
        applicationMember.paymentInterval = this.paymentInterval;
        applicationMember.accountHolder = this.accountHolder;
        applicationMember.iban = this.iban;
        applicationMember.bic = this.bic;
        applicationMember.acceptSepa = this.acceptSepa;

        // Weitere Informationen
        applicationMember.emergencyContact = this.emergencyContact;
        applicationMember.additionalInformation = this.additionalInformation;
        applicationMember.familyMembers = this.familyMembers;
        applicationMember.acceptDataProtection = this.acceptDataProtection;
        applicationMember.acceptStatute = this.acceptStatute;
        applicationMember.acceptContributionRegulations = this.acceptContributionRegulations;
        applicationMember.member = this.member;
        applicationMember.hasFilesUploadedByMember = false;
        applicationMember.files = this.files;
        applicationMember.filterFlags = this.filterFlags;
        applicationMember.classifications = this.classifications;

        return applicationMember;
    }

    getFullName() {
        return this.firstname + ' ' + this.lastname;
    }

    serialize() {
        let applicationMember = Object.assign({}, this);

        if (this.contractStart) {
            applicationMember.contractStart = format(parse(this.contractStart, 'dd.MM.yyyy', new Date()), 'yyyy-MM-dd');
        }

        if (this.birthdate) {
            applicationMember.birthdate = format(parse(this.birthdate, 'dd.MM.yyyy', new Date()), 'yyyy-MM-dd');
        }

        if (this.title && this.title.id) {
            applicationMember.title = this.title.id;
        }

        applicationMember.departments = applicationMember.departments.map(department => department.id);

        if (applicationMember.paymentInterval === 'monthly') {
            applicationMember.paymentInterval = {
                type: 'monthly',
                day: 1,
            };
        } else if (applicationMember.paymentInterval === 'quarterly') {
            applicationMember.paymentInterval = {
                type: 'quarterly',
                offsetDay: 0,
                offsetMonth: 0,
            };
        } else if (applicationMember.paymentInterval === 'yearly') {
            applicationMember.paymentInterval = {
                type: 'yearly',
                day: 1,
                month: 1,
            };
        } else if (applicationMember.paymentInterval === 'half-yearly') {
            applicationMember.paymentInterval = {
                type: 'halfYearly',
                offsetDay: 0,
                offsetMonth: 0,
            };
        } else {
            applicationMember.paymentInterval = null;
        }

        return applicationMember;
    }
}
